import {
    getData,
} from './Services'

export const getOfertas = async (user_id) => {
    const res = await getData(`/ofertasdet/busqueda_id_ofcab?&user_id=${user_id}&page=1&perPage=20`);
    return res
}

export const getOfertasPaginate = async ({
  searchTerm,
  selectedRamo,
  selectedRubro,
  selectedSubrubro,
  selectedMarca,
  page,
  perPage,
  user_id,
  orderBy,
  orden,
  ofcab_id
}) => { 
  const params = new URLSearchParams();

  if (searchTerm) params.append("search", searchTerm);
  if (selectedRamo) params.append("ramo_Id", selectedRamo);
  if (selectedRubro) params.append("rubro_Id", selectedRubro);
  if (selectedSubrubro) params.append("subrubro_Id", selectedSubrubro);
  if (selectedMarca) params.append("marca_Id", selectedMarca);
  if (page) params.append("page", page);
  if (perPage) params.append("perPage", perPage);
  if (user_id) params.append("user_id", user_id);
  if (orderBy) params.append("orderBy", orderBy);
  if (orden) params.append("orden", orden);
  if (ofcab_id) params.append("ofcab_id", ofcab_id);

  const res = await getData(`/ofertasdet/busqueda_id_ofcab?${params.toString()}`);

  return res;
};